import { render, staticRenderFns } from "./StudyCard.vue?vue&type=template&id=75505af4&scoped=true&"
import script from "./StudyCard.vue?vue&type=script&lang=js&"
export * from "./StudyCard.vue?vue&type=script&lang=js&"
import style0 from "./StudyCard.vue?vue&type=style&index=0&id=75505af4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75505af4",
  null
  
)

export default component.exports